import { useCallback, useState } from "react";

export function useToggle(initial = false): [boolean, (value?: boolean) => void] {
  const [open, setOpen] = useState(initial);

  // If value is boolean, set directly; otherwise toggle
  const toggle = useCallback((value?: boolean) => {
    if (typeof value === "boolean") {
      setOpen(value);
    } else {
      setOpen((prev) => !prev);
    }
  }, []);

  return [open, toggle];
}